export const AUDIO_RECORDING_SESSION_TYPE = "Audio Recording Session";
export const REGULAR_AI_SESSION_TYPE = "Regular AI Session";

export const SESSION_REVIEW_TABS = {
  overview: { id: "overview", titleStringId: "Overview" },
  transcript: { id: "transcript", titleStringId: "Transcript" },
  summary: { id: "summary", titleStringId: "Summary" },
  analytics: { id: "analytics", titleStringId: "Analytics" },
};

export const AUDIO_SESSION_TYPES: {
  [key: string]: { id: AudioSessionType; titleStringId: string };
} = {
  individual: { id: "individual-patient", titleStringId: "Individual" },
  dictation: { id: "dictation", titleStringId: "Dictation" },
  couple: { id: "couple", titleStringId: "Couple" },
};

// two main session types in schedule session modal
export const AI_APPOINTMENT_TYPES = {
  video: { id: REGULAR_AI_SESSION_TYPE, titleStringId: "Telehealth" },
  audio: { id: AUDIO_RECORDING_SESSION_TYPE, titleStringId: "In-person" },
};
